// extracted by mini-css-extract-plugin
var _1 = "img-Ei5e3";
var _2 = "link-t541Q";
var _3 = "message-Jpi96";
var _4 = "oops-NSSMm";
var _5 = "wrapper-vzq3t";
export { _1 as "img", _2 as "link", _3 as "message", _4 as "oops", _5 as "wrapper" }
